import { render } from "./FileStructEditor.vue?vue&type=template&id=1f032168"
import script from "./FileStructEditor.vue?vue&type=script&lang=js"
export * from "./FileStructEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__